<div class="salon_market_header">
    <header>

        <!--NAV STRAT Desktop-->
        <div class="">
            <div class="py-1 container headerContainer">
                <div class="main-menu text-center d-flex justify-content-between w-100">
                    <span class="lookzup_logo"><a routerLink="/">
                    <img  src="./assets/images/home-screen_logo.png" alt="logo" class="img-fluid"></a>
                </span>
                    <nav class="d_menu" style=" display: flex;
                    align-items: center; ">
                        <ul>
                            <!-- <li > <a [routerLink]="['/']">Home</a>
                            </li>
                            <li><a [routerLink]="['/', 'features']">Features</a>
                            </li>
                            <li><a [routerLink]="['/', 'download']">Download</a>
                            </li>
                            <li><a [routerLink]="['/', 'help']">Help</a>
                            </li> -->
                            <li class=""><a style="font-weight: 400; color: #777777;">manage like a pro</a>
                            </li>
                          
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
        <!--// NAV END-->
        <!--NAV STRAT Tab and Mobile-->

    </header>
</div>

<!-- Mobile header -->
<!-- <div class="mobile_header d-block d-lg-none">


<nav class="navbar navbar-expand-lg navbar-light ">

    <span class="lookzup_logo"><a routerLink="/">
        <img  src="./assets/images/home-screen_logo.png" alt="logo" class="img-fluid"></a>
    </span>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNavDropdown">
      <ul class="navbar-nav menu-border">
        <li class="nav-item active">
          <a class="nav-link" [routerLink]="['/']">Home <span class="sr-only">(current)</span></a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/', 'features']">Features</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/', 'download']">Download </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/', 'help']">Help </a>
        </li>
        <li class="nav-item active dwsq">
          <a class="nav-link" >Business login </a>
        </li>

      </ul>
    </div>
  </nav>
</div> -->
<!-- body -->

<div class="deature_section_part">
    <div class="container">
        <div class="feture_left_rg">
            <div class="row">
                <div class="col-sm-4">
                    <div class="d-none d-lg-block">
                    <div class="feture_img">
                        <img width="280px" height="565px" src="../../../../assets/images/phone-012.png">
                    </div>
                    <div class="feture_img " style="    max-height: 478px;
                    overflow: hidden;
                    margin-bottom: 0px;">
                        <img width="280px" height="565px" src="../../../../assets/images/phone-012.png">
                    </div>
                </div>
            </div>
                <div class="col-sm-3">
                    <div class="feture_img d-none d-lg-block img-container ">
                        <img width="280px" height="565px" src="../../../../assets/images/phone-01.png">
                    </div>
                </div>
                <div class="col-sm-5 ">
                    <div class="feture_heading form-container">
                        <!-- <h3>Search for Services near you.<br>See posts, people and jobs too.</h3> -->
                        <sm-login-form></sm-login-form>

                        <!-- <p>Mrs. Khan, a housewife now knows about the salon and beauty parlour near for her kids, husband and herself with services, rates etc. LookzUp helping her to book Home service and Online booking to avoid in covid situation.</p> -->
                    </div>
                    <div class="help-container">
                        <h1>How LookzUp can help you?</h1>
                        <p>This is a dedicated platform for the Beauty and Grooming industry. It manages businesses, bookings, employees, payments, expenditure, customers and promotions. A must have productivity tool for the business owners.</p>
                        <div class="row">
                            <div class="col-sm-5" (click)="openBusinessFeatures()">
                                <button class="featureButton">See the features<span class="material-icons " >
                                    navigate_next
                                    </span></button>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="get_std_frc">
                        <button type="button" mat-flat-button>
                         Read more</button>
                    </div> -->
                </div>
            </div>
        </div>




    </div>
</div>
<!-- footer -->
<footer class="footer-area-signup">
 
    <!--  Footer Bottom Area start -->
    <div class="footer_bottom">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-7 col-md-7">
                    <div class="copyright_area">
                        <p class="copyright-text" style="margin-bottom: 0px;">© 2024 <a class="lookzup_link" (click)="openLookzup()">Lookzup</a>. All rights reserved.</p>
                    </div>
                </div>
                <div class="col-lg-5 col-md-5">
                    <!-- <div class="footer_payment text-right">
                    <a href="javascript:void(0)"><img src="assets/images/payment.png" alt=""></a>
                </div> -->
                </div>
            </div>
        </div>
    </div>
    <!--  Footer Bottom Area End-->
</footer>
<!-- cookie banner -->
<sm-cookie-policy-banner></sm-cookie-policy-banner>

<!-- JS here -->
<script src="assets/js/jquery-1.12.4.min.js"></script>
<script src="assets/js/popper.min.js"></script>
<script src="assets/js/bootstrap.min.js"></script>
<script src="assets/js/modernizr-3.5.0.min.js"></script>
<script src="assets/js/jquery.meanmenu.min.js"></script>
<!-- ma5menu -->
<!-- <script src="assets/js/ma5-menu.min.js"></script> -->
<script src="assets/pluging/owl.carousel.min.js"></script>
<script>
  $('.owl-carousel').owlCarousel({
      loop: false,
      margin: 10,
      autoplay: true,
      autoplayTimeout: 3000,
      dots: true,
      autoplayHoverPause: true,
      nav: false,
      responsive: {
          0: {
              items: 2
          },
          600: {
              items: 3
          },
          1000: {
              items: 3
          }
      }
  })
</script>
<script>
  $(function() {
      $(".dropbtn").click(
          function() {
              $('.dropdown-menu', this).stop(true, true).fadeIn("fast");
              $(this).toggleClass('open');
              $('b', this).toggleClass("caret caret-up");
          },
          function() {
              $('.dropdown-menu', this).stop(true, true).fadeOut("fast");
              $(this).toggleClass('open');
              $('b', this).toggleClass("caret caret-up");
          });
  });
</script>
<script>
  // meanmenu
  $('#mobile-menu').meanmenu({
      meanMenuContainer: '.mobile-menu',
      meanScreenWidth: "992"
  });

  $('.info-bar').on('click', function() {
      $('.extra-info').addClass('info-open');
  })

  $('.close-icon').on('click', function() {
      $('.extra-info').removeClass('info-open');
  })
</script>
<!-- Call the script -->
<script>
  $(document).ready(function() {
      ma5menu({
          menu: '.site-menu',
          activeClass: 'active',
          position: 'left',
      });
  });
</script>
